import { Stack, Group, Anchor, Badge, SimpleGrid } from '@mantine/core'
import { IconSettings } from '@tabler/icons-react'
import { JiraSummaryWidget } from '@/components/jira/JiraSummaryWidget'
import JiraHealthScore from '@/components/jira/JiraHealthScore'
import JiraInsights from '@/components/jira/JiraInsights'
import { JiraSprintWidget } from '@/components/jira/JiraSprintWidget'
import { JiraIssueList } from '@/components/jira/JiraIssueList'
import { useCan } from '@/store/auth'
import { useJiraWebSocket } from '../../hooks/useJiraData'

export function JiraTab() {
  const can = useCan()
  const canAdmin = can('jira', 'admin')
  const { isLive } = useJiraWebSocket()

  return (
    <Stack gap="md">
      {/* Indicador Live/Polling */}
      <Group justify="flex-end">
        <Badge size="xs" color={isLive ? 'green' : 'gray'} variant="dot">
          {isLive ? 'Live' : 'Polling'}
        </Badge>
      </Group>

      {/* Resumo executivo completo */}
      <JiraSummaryWidget />

      {/* Saúde + Insights lado a lado */}
      <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
        <JiraHealthScore />
        <JiraInsights />
      </SimpleGrid>

      {/* Sprint ativo + velocidade */}
      <JiraSprintWidget />

      {/* Lista completa de issues */}
      <JiraIssueList />

      {/* Link de configuração (somente admin) */}
      {canAdmin && (
        <Group justify="flex-end">
          <Anchor href="/integracoes/jira/config" size="sm">
            <IconSettings size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
            Configuração Jira
          </Anchor>
        </Group>
      )}
    </Stack>
  )
}
